import Modal from "@material-ui/core/Modal";
import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import styled from "styled-components";

import { ErrorCard } from "../";
import { RelodeApiError } from "../../modules";

const styles = createStyles({
    root: {
        boxShadow: "none",
        outline: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});

const ErrorMessage = styled.div`
    width: 100%;
    text-align: center;
`;

interface ErrorModalProps extends WithStyles<typeof styles> {
    title?: string;
    subtitle?: string;
    error: RelodeApiError;
    onClose: () => void;
    open: boolean;
}

export const ErrorModal = withStyles(styles, { name: "ErrorCard" })(
    (props: ErrorModalProps) => {
        const {
            classes,
            error,
            onClose,
            title = "oops!",
            subtitle = "we have encountered something unexpected",
            ...other
        } = props;

        return (
            <Modal {...other} classes={classes}>
                <ErrorCard title={title} subtitle={subtitle} onClose={onClose}>
                    <ErrorMessage>{error.friendlyMessages}</ErrorMessage>
                </ErrorCard>
            </Modal>
        );
    }
);
